import axios from "axios";
import { CUSTOMER_API_BASE } from "../env";
import { getCustomerDocuments, getCustomerDocumentsByType, getExpiredInsurances } from "./documents";

export async function getCustomerById(customerId, facility, token) {
  let customer;
  let docs;
  let insurances;
  let archivedInsurances

  await Promise.all([
    axios
      .get(`${CUSTOMER_API_BASE}/customers/v1/${customerId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        customer = res.data;
      }),

    getCustomerDocumentsByType(customerId, 'INSURANCE', facility, token).then((res) => {
      insurances = res.data
    }),

    getCustomerDocuments(customerId, true, token).then((res) => {
      docs = res.data;
    }),

    getExpiredInsurances(customerId, facility, token).then((res) => {
      archivedInsurances = res.data;
    }),
  ]);

  customer = {
    ...customer,
    docs,
    insurances,
    archivedInsurances,
  };

  return customer;
}

export async function updateCustomer(customerId, body, token) {
  return axios.put(`${CUSTOMER_API_BASE}/customers/v1/${customerId}`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}



// WEBPACK FOOTER //
// ./src/api/customers.js